module.exports = __webpack_public_path__ + "img/5f2.1573555a.jpg";